const getOr = require('lodash/fp/getOr');

const getOrFalse = getOr(false);

module.exports = class BaseFormController {
  isFieldDisabled(field) {
    return this.disabled || getOrFalse(field, this.disabledFields);
  }

  isFieldRequired(field) {
    return getOrFalse(field, this.requiredFields);
  }
};
